import { mergeWithDefaults } from './formDraftStorage';

function formatDate(value) {
  if (!value) return '';
  if (typeof value === 'string') return value.slice(0, 10);
  return new Date(value).toISOString().slice(0, 10);
}

export function enquiryToFormValues(enquiry) {
  if (!enquiry) return null;

  return mergeWithDefaults({
    personal: {
      fullName: enquiry.personal?.fullName ?? '',
      dateOfBirth: formatDate(enquiry.personal?.dateOfBirth),
      gender: enquiry.personal?.gender ?? '',
      mobile: enquiry.personal?.mobile ?? '',
      whatsapp: enquiry.personal?.whatsapp ?? '',
      email: enquiry.personal?.email ?? '',
      address: {
        city: enquiry.personal?.address?.city ?? '',
        state: enquiry.personal?.address?.state ?? '',
      },
    },
    education: {
      highestQualification: enquiry.education?.highestQualification ?? '',
      highestQualificationOther: enquiry.education?.highestQualificationOther ?? '',
      currentStatus: enquiry.education?.currentStatus ?? '',
      collegeName: enquiry.education?.collegeName ?? '',
      branch: enquiry.education?.branch ?? '',
      yearOfPassing: enquiry.education?.yearOfPassing ?? '',
      cgpaOrPercentage: enquiry.education?.cgpaOrPercentage ?? '',
    },
    work: {
      totalExperience: enquiry.work?.totalExperience ?? '',
      lastCompany: enquiry.work?.lastCompany ?? '',
      lastDesignation: enquiry.work?.lastDesignation ?? '',
      knownSkills: Array.isArray(enquiry.work?.knownSkills)
        ? enquiry.work.knownSkills.join(', ')
        : enquiry.work?.knownSkills ?? '',
    },
    coursePreference: {
      courseInterested: enquiry.coursePreference?.courseInterested ?? '',
      batchMode: enquiry.coursePreference?.batchMode ?? '',
      preferredStartMonth: enquiry.coursePreference?.preferredStartMonth ?? '',
      hearAboutUs: enquiry.coursePreference?.hearAboutUs ?? '',
      hearAboutUsOther: enquiry.coursePreference?.hearAboutUsOther ?? '',
      primaryGoalAfterCourse: enquiry.coursePreference?.primaryGoalAfterCourse ?? '',
    },
    careerGoals: {
      whyJoin: enquiry.careerGoals?.whyJoin ?? '',
      careerGoal2To3Years: enquiry.careerGoals?.careerGoal2To3Years ?? '',
      lookingFor: enquiry.careerGoals?.lookingFor ?? [],
      expectedSalaryLpa: enquiry.careerGoals?.expectedSalaryLpa ?? '',
      willingToRelocate: enquiry.careerGoals?.willingToRelocate ?? '',
    },
    skillRatings: enquiry.skillRatings,
    declaration: { accepted: false },
  });
}
